class APIPerformanceTracker {
  constructor() {
    if (APIPerformanceTracker.instance) {
      // eslint-disable-next-line no-constructor-return
      return APIPerformanceTracker.instance;
    }
    this.apiEndpointList = [];
    this.observer = new PerformanceObserver((list) => {
      // Log all entries
      const perfEntries = list.getEntries();
      perfEntries.forEach((entity) => {
        this.logAPIPerfMetric(entity);
      });
    });
    this.observer.observe({
      entryTypes: ['resource'],
    });
    APIPerformanceTracker.instance = this;
  }

  logAPIPerfMetric(entity) {
    const apiURL = new URL(entity.name);
    if (this.apiEndpointList.indexOf(apiURL.pathname) > -1) {
      // eslint-disable-next-line no-console
      console.log(`Name: ${apiURL.pathname
      }, Type: ${entity.entryType
      }, TCP handshake: ${entity.connectEnd - entity.connectStart
      }, DNS lookup: ${entity.domainLookupEnd - entity.domainLookupStart
      }, Request Time: ${entity.responseStart - entity.requestStart
      }, Time to fetch: ${entity.responseEnd - entity.fetchStart
      },  Duration: ${entity.duration}\n`);
    }
  }

  trackPerformance(apiEndpointName) {
    this.apiEndpointList.push(apiEndpointName);
  }
}

export default APIPerformanceTracker;
